import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import Typical from "react-typical";

import imgBack from "../../../src/assets/images/mailz.jpeg";
import SocialMediaLinks from "../../components/SocialMediaLinks";
import Footer from "../../PortfolioContainer/footer/Footer";
import Animations from "../../utilities/Animations";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import "./ContactMe.css";

export default function ContactMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);

  const updateBanner = () => {
    if (banner && name.trim() && email.trim() && message.trim()) {
      setBanner("");
    }
  };

  const handleName = (e) => {
    setName(e.target.value);
    updateBanner();
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
    updateBanner();
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
    updateBanner();
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      setName(name.trim());
      setEmail(email.trim());
      setMessage(message.trim());
      let data = {
        name,
        email,
        message,
      };
      setBool(true);
      if (
        name.trim().length === 0 ||
        email.trim().length === 0 ||
        message.trim().length === 0
      ) {
        setBanner("All fields are required");
        setBool(false);
        return;
      }
      const res = await axios.post(
        `https://techgeeks-api-v1.cyclic.app/api/contact`,
        data
      );
      if (res.status === 200) {
        setBanner(res.data.msg);
        toast.success(res.data.msg);
        setBool(false);
        setTimeout(() => {
          setBanner("");
        }, 2000);
        setName("");
        setEmail("");
        setMessage("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main-container fade-in" id={props.id || ""}>
      <ScreenHeading subHeading={"Lets Keep In Touch"} title={"Contact Me"} />
      <div className="central-form">
        <div className="col">
          <h2 className="title">
            <Typical loop={Infinity} steps={["Get In Touch 📧", 1000]} />
          </h2>
          <SocialMediaLinks />
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>{`Send Your Email Here >>>`}</h4>
            <img src={imgBack} alt="social media background" />
          </div>
          <form onSubmit={submitForm}>
            <p>{banner}</p>
            <label htmlFor="name">Name</label>
            <input type="text" onChange={handleName} value={name} />

            <label htmlFor="email">Email</label>
            <input type="email" onChange={handleEmail} value={email} />

            <label htmlFor="message">Message</label>
            <textarea type="text" onChange={handleMessage} value={message} />

            <div className="send-btn">
              <button type="submit">
                send
                {bool ? (
                  <span className="spinner-border spinner-border-sm text-light"></span>
                ) : (
                  ""
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
